<template>
  <div class="template desktopChat">
    <el-tabs type="card" v-model="businessGroupCode" @tab-click="changeTab">
      <el-tab-pane v-for="item in businessGroupData" :name="item.code">
        <span slot="label">{{item.name}}</span>
        <el-form class="localeCon" v-if="langList&&langList.length>0">
          <el-form-item :label="$t('im.common.locale')">
            <el-select v-model="langId" :placeholder="$t('im.common.placeholderLanguage')" @change="changeLang">
              <el-option
                v-for="item in langList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="chatBox boxShadow">
          <div class="leftBox" id="leftBox">
            <div class="leftTit" :style="{'background':bgColorTxt}">
              <ul>
                <li>
                  <span v-if="isLogoPic&&util.isNotEmpty(logoUrl)" @click="editLogoInfo(1)"><img :src="logoUrl"/></span>
                  <span v-else @click="editLogoInfo(0)">{{$t('im.desktopChat.clickEditLogo')}}</span>
                </li>
                <li>
                  <span v-if="isBgColor&&util.isNotEmpty(bgColorTxt)" @click="editBgColorInfo(1)">{{$t('im.desktopChat.clickEditBgColor')}}</span>
                  <p v-else @click="editBgColorInfo(0)">{{$t('im.desktopChat.clickEditBgColor')}}</p>
                </li>
              </ul>
            </div>
            <div :style="{'height':util.accDiv(height,2)+'px'}">
              <div :style="{'height':util.accSub((util.accDiv(height,2)),120)+'px'}"></div>
              <div class="chatImg">
                <ul>
                  <li><img class="face_img" src="@/assets/IM/face.png"/></li>
                  <li><img src="@/assets/IM/picture.png"/></li>
                </ul>
              </div>
            </div>
            <div class="btn flexEnd"><el-button type="primary" size="mini">{{$t('im.common.send')}}</el-button></div>
          </div>
          <div class="rightBox" :style="{'height':util.accDiv(height,1.65)+'px'}">
            <ul>
              <li>
                <p v-if="isAdPic_1&&util.isNotEmpty(adUrl_1)" @click="clickAdPop(3)"><img :src="adUrl_1"/></p>
                <p @click="clickAdPop(1)" v-else>{{$t('im.desktopChat.clickAd1')}}</p>
              </li>
              <li>
                <p v-if="isAdPic_2&&util.isNotEmpty(adUrl_2)" @click="clickAdPop(4)"><img :src="adUrl_2"/></p>
                <p @click="clickAdPop(2)" v-else>{{$t('im.desktopChat.clickAd2')}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="itemBox">
          <div class="flexStart">
            <span>{{$t('im.desktopChat.isVerify')}}：</span>
            <el-radio v-model="verifyTxt" label="1" @change="editVerify">{{$t('im.common.yes')}}</el-radio>
            <el-radio v-model="verifyTxt" label="0" @change="editVerify">{{$t('im.common.no')}}</el-radio>
          </div>
          <div class="flexCenter">
            <el-button type="primary" size="small" @click="submit">{{$t('im.bt.save')}}</el-button>
            <el-button size="small">{{$t('im.bt.cancel')}}</el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="$t('im.desktopChat.editLogo')" :visible.sync="editLogo" :before-close="cancelLogoInfo">
      <el-form class="div_form" label-width="80px">
        <el-form-item :label="$t('im.desktopChat.logoHrefUrl')">
          <el-input v-model="logoHrefUrl" :placeholder="$t('im.desktopChat.inputLogoHrefUrl')"></el-input>
        </el-form-item>
        <el-form-item label="logo">
          <el-upload class="upload-demo" ref="uploadUrl" drag :action="uploadMultiUrl" :headers="{isAjax:true}" :file-list="logoList" list-type="picture" :on-success="logoUrlSuc" :on-error="logoUrlErr">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">{{$t('im.upload.uploadTipPrefix')}}<em>{{$t('im.upload.uploadTipSuffix')}}</em></div>
            <div class="el-upload__tip" slot="tip">{{$t('im.upload.uploadPicTip')}}</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary" size="small" @click="editLogoInfo(2)">{{$t('im.bt.save')}}</el-button>
        <el-button size="small" @click="cancelLogoInfo">{{$t('im.bt.cancel')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('im.desktopChat.editAd')" :visible.sync="editAd" :before-close="cancelAd">
      <el-form class="div_form" label-width="80px">
        <el-form-item :label="$t('im.desktopChat.logoHrefUrl')">
          <el-input v-model="adHrefUrl" :placeholder="$t('im.desktopChat.inputLogoHrefUrl')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('im.desktopChat.adPic')">
          <el-upload class="upload-demo" ref="uploadAd" drag :action="uploadMultiUrl" :headers="{isAjax:true}" :file-list="adUrlList" list-type="picture" :on-success="logoAdSuc" :on-error="logoAdErr">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">{{$t('im.upload.uploadTipPrefix')}}<em>{{$t('im.upload.uploadTipSuffix')}}</em></div>
            <div class="el-upload__tip" slot="tip">{{$t('im.upload.uploadPicTip')}}</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary" size="small" @click="submitAd">{{$t('im.bt.save')}}</el-button>
        <el-button size="small" @click="cancelAd">{{$t('im.bt.cancel')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('im.desktopChat.editBgColor')" :visible.sync="editBgColor" class="editBgColor" :before-close="cancelBgColorInfo">
      <div class="block flexCenter">
        <span class="demonstration">{{$t('im.desktopChat.background')}}</span>
        <el-color-picker v-model="uploadBgColorTxt"></el-color-picker>
      </div>
      <div class="flexCenter">
        <el-button type="primary" size="small" @click="editBgColorInfo(2)">{{$t('im.bt.save')}}</el-button>
        <el-button size="small" @click="cancelBgColorInfo">{{$t('im.bt.cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  require('@/styles/IM/template.css')
  require('@/styles/IM/desktopChat.css')
  import apiDeployManagement from "@/api/im/deployManagement"
  import Util from "@/utils/IM/tradeDataUtil"
  import { localRead,localSave} from '@/utils/tools'
  export default {
    data() {
      return {
        util:Util,
        height: '',
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
        langList: JSON.parse(localRead('locale_IM')),  //语言列表
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        businessGroupCode: "",  //业务编码Code
        uploadMultiUrl: process.env.VUE_APP_BASE_API + '/serviceBusiness/api/upload/uploadMulti',  //上传图片文件地址
        langId: 'zh_CN',  //默认显示语言的ID
        logoType: 0,//logo是否编辑
        editLogo: false,   //是否显示编辑logo弹窗
        isLogoPic: false, //是否显示编辑后的logo
        uploadLogoUrl: '',  //上传logo图片地址
        logoUrl: '',  //logo图片地址
        logoHrefUrl: '',  //logo跳转地址
        logoList:[],//上传的logo文件列表
        bgColorType: 0,//背景色是否编辑
        editBgColor: false,   //是否显示编辑背景弹窗
        isBgColor: false, //是否显示编辑后的logo
        uploadBgColorTxt: '#eeeeee', //上传背景色
        bgColorTxt: '#eeeeee', //背景色
        editAd: false, //是否显示广告banner弹窗
        adHrefUrl: '',  //上传banner广告跳转地址
        isAdPic_1: false, //是否显示编辑后的logo
        uploadAdUrl_1: '',  //上传banner1广告图片地址
        adUrl_1: '',  //banner1广告图片地址
        adHrefUrl_1: '',  //banner广告跳转地址
        isAdPic_2: false, //是否显示编辑后的logo
        uploadAdUrl_2: '',  //上传banner2广告图片地址
        adUrl_2: '',  //banner2广告图片地址
        adHrefUrl_2: '',  //banner广告跳转地址
        adUrlList:[],//上传的banner广告文件列表
        adType: '',  //广告类型
        verifyTxt: "1",  //默认开户验证码
        chatPageList:[] , //聊天页面配置列表
        chatPage:'', //当前聊天页面配置
      }
    },
    methods: {
      docHeight() {
        this.height = window.innerHeight || document.documentElement.clientHeight
      },
      /*初始化业务组tab*/
      initTab() {
        if (this.businessGroupData.length > 0) {
          this.businessGroupCode = this.businessGroupData[0].code
        }
      },
      /*业务组tab*/
      changeTab(val) {
        this.businessGroupCode = val.name
        this.uploadBgColorTxt = '#eeeeee'
        this.brushChatPage(this.chatPageList)
      },
      /*选择语言*/
      changeLang(val) {
        this.brushChatPage(this.chatPageList)
      },
      /*编辑logo*/
      editLogoInfo(type) {//0：弹窗出现；1：编辑logo；2：确认logo；
        this.logoType = type
        if (type == 0) {
          this.editLogo = true
          this.logoHrefUrl = ''
        } else if (type == 1) {
          this.editLogo = true
          this.isLogoPic = true
          let newData = []
          newData.push({name:this.chatPage.logoAddress,url:this.chatPage.logoAddress})
          this.logoList = newData
        } else if (type == 2) {
          this.editLogo = false
          this.isLogoPic = true
          this.logoUrl = this.uploadLogoUrl
          this.$refs.uploadUrl.clearFiles()
        }
      },
      cancelLogoInfo() {
        this.editLogo = false
        if (this.logoType == 0) {
          this.logoHrefUrl = ''
          this.uploadLogoUrl = ''
        } else if (this.logoType == 1) {
          this.logoHrefUrl = this.chatPage.logoRedirectAddress
          this.logoUrl = this.chatPage.logoAddress
        }
        this.$refs.uploadUrl.clearFiles()
      },
      /*logo上传成功*/
      logoUrlSuc(data) {
        let newData = []
        newData.push({ name: data.result, url: data.result })
        this.logoList = newData
        this.uploadLogoUrl = data.result
      },
      /*logo上传失败*/
      logoUrlErr(data){
        this.$message.error(window.$t('im.upload.uploadPicFail'))
      },
      /*编辑背景颜色*/
      editBgColorInfo(type) {//0：弹窗出现；1：确认背景颜色；
        this.bgColorType = type
        if (type == 0) {
          this.editBgColor = true
          this.uploadBgColorTxt = ''
        } else if (type == 1) {
          this.editBgColor = true
          this.isBgColor = true
        } else if (type == 2) {
          this.editBgColor = false
          this.isBgColor = true
          this.bgColorTxt = this.uploadBgColorTxt
        }
      },
      cancelBgColorInfo() {
        this.editBgColor = false
        if (this.bgColorType == 0) {
          this.uploadBgColorTxt = '#eeeeee'
        } else if (this.bgColorType == 1) {
          this.uploadBgColorTxt = this.chatPage.backColor
        }
      },
      /*编辑banner广告*/
      clickAdPop(type) {
        this.adType = type
        let newAdUrlData = []
        if (type == 1 || type == 2) {
          this.editAd = true
          this.adHrefUrl = ''
        } else if (type == 3) {
          this.editAd = true
          this.isAdPic_1 = true
          this.adHrefUrl = this.adHrefUrl_1
          this.uploadAdUrl_1 = this.adUrl_1
          newAdUrlData.push({ name: this.chatPage.oneAddress, url: this.chatPage.oneAddress })
          this.adUrlList = newAdUrlData
        } else if (type == 4) {
          this.editAd = true
          this.isAdPic_2 = true
          this.adHrefUrl = this.adHrefUrl_2
          this.uploadAdUrl_2 = this.adUrl_2
          newAdUrlData.push({ name: this.chatPage.twoAddress, url: this.chatPage.twoAddress })
          this.adUrlList = newAdUrlData
        }
        console.log(this.adUrl_1)
      },
      /*banner广告上传成功*/
      logoAdSuc(data) {
        let newData = []
        newData.push({ name: data.result, url: data.result })
        this.adUrlList = newData
        if (this.adType == 1 || this.adType == 3) {
          this.uploadAdUrl_1 = data.result
        } else if (this.adType == 2 || this.adType == 4) {
          this.uploadAdUrl_2 = data.result
        }
      },
      /*文件上传失败*/
      logoAdErr(data){
        this.$message.error(window.$t('im.upload.uploadPicFail'))
      },
      /*确认banner广告*/
      submitAd() {
        this.editAd = false
        if (this.adType == 1 || this.adType == 3) {
          this.isAdPic_1 = true
          this.adUrl_1 = this.uploadAdUrl_1
          this.adHrefUrl_1 = this.adHrefUrl
        } else if (this.adType == 2 || this.adType == 4) {
          this.isAdPic_2 = true
          this.adUrl_2 = this.uploadAdUrl_2
          this.adHrefUrl_2 = this.adHrefUrl
        }
        this.$refs.uploadAd.clearFiles()
      },
      /*取消banner广告*/
      cancelAd() {
        this.editAd = false
        if (this.adType == 1 || this.adType == 2) {
          this.adHrefUrl = ''
          this.uploadAdUrl_1 = ''
          this.uploadAdUrl_2 = ''
        } else if (this.adType == 3) {
          this.uploadAdUrl_1 = this.chatPage.oneAddress
          this.adHrefUrl = this.chatPage.oneRedirectAddress
        } else if (this.adType == 4) {
          this.uploadAdUrl_2 = this.chatPage.twoAddress
          this.adHrefUrl = this.chatPage.twoRedirectAddress
        }
        this.$refs.uploadAd.clearFiles()
      },
      /*选择是否开户验证码*/
      editVerify(data) {
        this.verifyTxt = data
      },
      /*刷选不同业务组不同语言下的聊天页面配置*/
      brushChatPage(data) {
        let flag = false
        for (let i in data) {
          if (data[i].bizCode == this.businessGroupCode && data[i].locale == this.langId) {
            flag = true
            this.chatPage = data[i]

            this.isBgColor = true
            this.bgColorTxt = data[i].backColor

            this.isLogoPic = true
            this.logoUrl = data[i].logoAddress
            this.logoHrefUrl = data[i].logoRedirectAddress
            let newLogoData = []
            newLogoData.push({name:data[i].logoAddress,url:data[i].logoAddress})
            this.logoList = newLogoData

            this.isAdPic_1 = true
            this.adUrl_1 = data[i].oneAddress
            this.adHrefUrl_1 = data[i].oneRedirectAddress
            this.isAdPic_2 = true
            this.adUrl_2 = data[i].twoAddress
            this.adHrefUrl_2 = data[i].twoRedirectAddress

            this.verifyTxt = data[i].validationEnable.toString()
            this.uploadBgColorTxt=data[i].backColor
          }
        }
        if (!flag) {
          this.bgColorTxt = ''
          this.isLogoPic = false
          this.logoUrl = ''
          this.isAdPic_1 = false
          this.adUrl_1 = ''
          this.isAdPic_2 = false
          this.adUrl_2 = ''
          this.chatPage = ''
        }
      },
      /*初始化所有聊天页面配置*/
      initChatPageVo() {
        let data = {
          companyId: this.userInfo.companyId
        }
        apiDeployManagement.queryConChatPageList(data).then(res => {
          if (res.code == 0) {
            this.chatPageList = res.result
            this.brushChatPage(res.result)
          }
        })
      },
      /*添加聊天页面配置*/
      addChatPage() {
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          bizCode: this.businessGroupCode,
          companyId: this.userInfo.companyId,
          locale: this.langId,
          logoAddress: this.logoUrl,
          logoRedirectAddress: this.logoHrefUrl,
          backColor: this.bgColorTxt,
          oneAddress: this.adUrl_1,
          oneRedirectAddress: this.adHrefUrl_1,
          twoAddress: this.adUrl_2,
          twoRedirectAddress: this.adHrefUrl_2,
          validationEnable:this.verifyTxt
        }
        apiDeployManagement.addConChatPage(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.addSuc'))
            this.initChatPageVo()
          } else {
            this.$message.error(window.$t('im.common.addFail'));
          }
        })
      },
      /*更新聊天页面配置*/
      updateChatPage() {
        let data = {
          id: this.chatPage.id,
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          bizCode: this.businessGroupCode,
          companyId: this.userInfo.companyId,
          locale: this.langId,
          logoAddress: this.logoUrl,
          logoRedirectAddress: this.logoHrefUrl,
          backColor: this.bgColorTxt,
          oneAddress: this.adUrl_1,
          oneRedirectAddress: this.adHrefUrl_1,
          twoAddress: this.adUrl_2,
          twoRedirectAddress: this.adHrefUrl_2,
          validationEnable: this.verifyTxt
        }
        apiDeployManagement.updateConChatPage(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.updateSuc'))
            this.initChatPageVo()
          } else {
            this.$message.error(window.$t('im.common.updateFail'));
          }
        })
      },
      /*保存聊天页面配置*/
      submit() {
        if (Util.isNotEmpty(this.chatPage)) {
          this.updateChatPage()
        } else {
          if (Util.isNotEmpty(this.logoUrl) || Util.isNotEmpty(this.bgColorTxt) || Util.isNotEmpty(this.adUrl_1) || Util.isNotEmpty(this.adUrl_2)) this.addChatPage()
        }
      }
    },
    mounted() {
      this.docHeight()
      this.initTab();
      this.initChatPageVo();
    }
  }
</script>
<style>
  .desktopChat .demonstration{margin-right: 20px}
  .desktopChat .div_form .el-select{width: 100%}
  .desktopChat .editBgColor .el-dialog{width: 30%}
</style>
